<div class="workflow-test">
  <p class="test-intro">{{_(KEYS.CRUD.TEST_DIAGRAM_HELP)}}</p>
  <div class="test-toolbar">
    <div class="test-actions">
      <button type="button" class="btn btn-outline-primary" (click)="run()" [disabled]="playing || !stages.length">
        <i class="fa fa-play" aria-hidden="true"></i> {{_(paused ? KEYS.CRUD.TEST_CONTINUE : KEYS.CRUD.RUN_TEST)}}
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="pause()" [disabled]="!busy || paused">
        <i class="fa fa-pause" aria-hidden="true"></i> {{_(KEYS.CRUD.TEST_PAUSE)}}
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="advance()"
              [disabled]="!stages.length || finished || (busy && !paused)">
        <i class="fa fa-step-forward" aria-hidden="true"></i> {{_(KEYS.CRUD.TEST_NEXT)}}
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="reset()" [disabled]="!results">
        <i class="fa fa-undo" aria-hidden="true"></i> {{_(KEYS.CRUD.TEST_RESET)}}
      </button>
    </div>
    <span role="status" class="test-progress">
      <ng-container *ngIf="stale; else progress">{{_(KEYS.CRUD.TEST_STALE)}}</ng-container>
      <ng-template #progress>
        <ng-container *ngIf="results">{{completed.size}} / {{stages.length}} {{_(KEYS.CRUD.TEST_STEPS_CHECKED)}}<span *ngIf="paused"> · {{_(KEYS.CRUD.TEST_PAUSED)}}</span></ng-container>
        <ng-container *ngIf="!results">{{_(KEYS.CRUD.TEST_LOCAL_ONLY)}}</ng-container>
      </ng-template>
    </span>
  </div>
  <p class="test-note">{{_(KEYS.CRUD.TEST_KEEP_HELP)}}</p>
  <!-- light sheet behind the diagram, so the white cards stand out; the diagram itself keeps its box for the line positions -->
  <div class="test-sheet">
  <div class="flow-diagram" #diagram>
    <svg class="flow-lines" [attr.width]="diagramWidth" [attr.height]="diagramHeight" aria-hidden="true">
      <path *ngFor="let edge of edges" [attr.d]="edge.path" [attr.data-edge]="edge.id"
            [class.is-visited]="visitedEdges.has(edge.id)" [class.skip-edge]="edge.branch === 'no'" />
      <circle #marker class="flow-marker" [class.is-blocked]="isBlocked(current)" r="6" visibility="hidden" />
    </svg>
    <div class="flow-terminal flow-start"><i class="fa fa-play" aria-hidden="true"></i> {{_(KEYS.CRUD.TEST_START)}}</div>
    <section class="flow-row" *ngFor="let stage of stages; let index = index" [attr.data-row]="index">
      <div class="flow-decision-area" *ngIf="stage.conditional">
        <div class="flow-condition-text">{{stage.condition.error ? _(KEYS.CRUD.INVALID_CONDITION) : describe(stage.condition.root)}}</div>
        <div class="flow-decision" [attr.data-decision]="index"
             [class.is-evaluated]="evaluated.has(index)" [class.is-blocked]="isBlocked(index)" [attr.aria-label]="_(KEYS.CRUD.CHECK_CONDITION)">
          <i class="fa" [ngClass]="evaluated.has(index) ? results[index].result === null ? 'fa-question' : results[index].result ? 'fa-check' : 'fa-times' : 'fa-code-fork'" aria-hidden="true"></i>
        </div>
        <span class="flow-yes">{{_(KEYS.CRUD.YES)}}</span>
        <span class="flow-no">{{_(KEYS.CRUD.NO)}}</span>
      </div>
      <article class="flow-card" [attr.data-card]="index" [class.is-current]="current === index && !!results"
               [class.is-blocked]="isBlocked(index)"
               [class.is-completed]="completed.has(index) && results[index].result === true"
               [class.is-skipped]="evaluated.has(index) && results[index].result === false">
        <header class="flow-card-header">
          <span class="test-number">{{index + 1}}</span>
          <button type="button" class="stage-link" (click)="editStage.emit(index)">{{stageName(index)}} <i class="fa fa-angle-right" aria-hidden="true"></i></button>
          <span class="test-status" *ngIf="evaluated.has(index)">
            <i class="fa" [ngClass]="results[index].result === null ? 'fa-question-circle' : results[index].result ? 'fa-check' : 'fa-forward'" aria-hidden="true"></i>
            {{_(results[index].result === null ? KEYS.CRUD.TEST_BLOCKED : results[index].result ? completed.has(index) ? KEYS.CRUD.TEST_COMPLETED : KEYS.CRUD.TEST_EXECUTE : KEYS.CRUD.TEST_SKIPPED)}}
          </span>
          <button type="button" class="test-input-toggle" aria-haspopup="dialog" (click)="toggleInputs(index, $event)">
            <i class="fa fa-sliders" aria-hidden="true"></i> {{_(KEYS.CRUD.TEST_INPUTS)}}
            <span *ngIf="preparedCount(index)">({{preparedCount(index)}})</span>
          </button>
        </header>
        <div class="test-node-summary" *ngIf="!isBlocked(index)">
          <span *ngIf="!evaluated.has(index)">{{stage.groups[0]?.title || _(KEYS.CRUD.NO_QUESTIONNAIRES)}}</span>
          <button type="button" class="test-result-link" *ngIf="evaluated.has(index)" (click)="toggleInputs(index, $event)">
            {{_(results[index].reason)}}
            <span *ngIf="completed.has(index) && results[index].changes.length"> · {{results[index].changes.length}} {{_(results[index].changes.length === 1 ? KEYS.CRUD.TEST_CHANGED_VALUE : KEYS.CRUD.TEST_CHANGED_VALUES)}}</span>
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </button>
        </div>
        <div class="test-blockage" *ngIf="isBlocked(index)" role="alert">
          <ng-container *ngIf="blockingDetails(index) as blocker">
            <p><strong *ngIf="blocker.variable">{{blocker.variable}}: </strong>{{_(blocker.reason)}}</p>
            <button type="button" class="test-blockage-action" *ngIf="blocker.sourceIndex >= 0"
                    (click)="completeMissingInput(index, $event)">
              {{_(KEYS.CRUD.TEST_COMPLETE_VALUE)}} · {{_(KEYS.CRUD.STAGE)}} {{blocker.sourceIndex + 1}}:
              {{stageName(blocker.sourceIndex)}} <i class="fa fa-angle-right" aria-hidden="true"></i>
            </button>
            <small *ngIf="blocker.sourceIndex >= 0">{{_(KEYS.CRUD.TEST_RETRY_AFTER_INPUT)}}</small>
          </ng-container>
        </div>
      </article>
    </section>
    <div class="flow-terminal flow-end" [class.is-finished]="finished && completed.size === stages.length">
      <i class="fa fa-flag-checkered" aria-hidden="true"></i> {{_(KEYS.CRUD.TEST_END)}}
    </div>
  </div>
  </div>
  <ng-container *ngIf="inspected !== null">
    <div class="test-backdrop" (click)="closeInspector()"></div>
    <section class="test-inspector" role="dialog" aria-modal="true" aria-labelledby="test-inspector-title">
      <header class="test-inspector-header">
        <div><small>{{_(KEYS.CRUD.TEST_INPUTS)}} · {{_(KEYS.CRUD.STAGE)}} {{inspected + 1}}</small>
          <h3 id="test-inspector-title">{{stageName(inspected)}}</h3></div>
        <button type="button" class="btn btn-outline-secondary" (click)="closeInspector()" [attr.aria-label]="_(KEYS.CRUD.TEST_CLOSE)">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </header>
      <div class="test-inspector-body">
        <p class="test-note">{{_(KEYS.CRUD.TEST_KEEP_HELP)}}</p>
        <p class="test-note">{{_(KEYS.CRUD.TEST_DERIVATION_HELP)}}</p>
        <div class="test-inspector-fields">
        <div class="test-group" *ngFor="let group of stages[inspected].groups">
          <div class="test-group-title"><i class="fa fa-file-text-o" aria-hidden="true"></i> {{group.title}}</div>
          <p class="test-empty" *ngIf="!group.fields.length">{{_(group.unavailable ? KEYS.CRUD.TEST_SOURCE_UNAVAILABLE : KEYS.CRUD.TEST_NO_MAPPING)}}</p>
          <div class="test-field" *ngFor="let field of group.fields">
            <div class="test-field-label">
              <label [for]="'test-' + field.key">{{field.source}}</label>
              <small *ngIf="field.names.length; else derivedSource"><i class="fa fa-long-arrow-right" aria-hidden="true"></i> {{field.names.join(', ')}}</small>
              <ng-template #derivedSource><small>{{_(KEYS.CRUD.TEST_DERIVATION_SOURCE)}}</small></ng-template>
            </div>
            <div class="test-field-control">
              <select *ngIf="inputType(field) === 'gender'; else standardInput" class="form-control"
                      [id]="'test-' + field.key" [ngModel]="inputValue(inspected, field)" [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="setInput(field.key, $event)">
                <option [ngValue]="undefined">{{_(KEYS.CRUD.PLEASE_SELECT)}}</option>
                <option value="male">{{_(KEYS.CRUD.TEST_MALE)}}</option>
                <option value="female">{{_(KEYS.CRUD.TEST_FEMALE)}}</option>
                <option value="diverse">{{_(KEYS.CRUD.TEST_DIVERSE)}}</option>
              </select>
              <ng-template #standardInput>
              <select *ngIf="inputType(field) === 'boolean'; else typedInput" class="form-control"
                      [id]="'test-' + field.key" [ngModel]="inputValue(inspected, field)" [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="setInput(field.key, $event)">
                <option [ngValue]="undefined">{{_(KEYS.CRUD.PLEASE_SELECT)}}</option>
                <option [ngValue]="true">{{_(KEYS.CRUD.YES)}}</option><option [ngValue]="false">{{_(KEYS.CRUD.NO)}}</option>
              </select>
              <ng-template #typedInput>
                <input class="form-control" [type]="inputType(field)" [id]="'test-' + field.key"
                       [ngModel]="inputValue(inspected, field)" [ngModelOptions]="{standalone: true}"
                       (ngModelChange)="setInput(field.key, $event)" [placeholder]="_(KEYS.CRUD.EXAMPLE_VALUE)" />
              </ng-template>
              </ng-template>
              <small class="test-auto-value" *ngIf="isAutomatic(inspected, field)">{{_(KEYS.CRUD.TEST_AUTOMATIC)}}</small>
              <label class="test-use-value"><input type="checkbox" [checked]="enabled.has(field.key)"
                (change)="toggleValue(field.key, $event.target.checked)"> {{_(KEYS.CRUD.TEST_SET_VALUE)}}</label>
              <small *ngIf="!enabled.has(field.key) && !isAutomatic(inspected, field)">{{_(KEYS.CRUD.TEST_KEEP_VALUE)}}: {{previousValue(inspected, field)}}</small>
            </div>
          </div>
        </div>
        </div>
        <div class="test-outcome" *ngIf="evaluated.has(inspected)">
          <p>{{_(results[inspected].reason)}}</p>
          <div class="test-trace" *ngFor="let trace of results[inspected].traces">
            <span>{{describe(trace.rule)}}</span>
            <small>{{trace.result === null ? _(trace.reason) : formatValue(trace.value) + ' · ' + _(trace.result ? KEYS.CRUD.CONDITION_MET : KEYS.CRUD.CONDITION_NOT_MET)}}</small>
          </div>
          <div class="test-changes" *ngIf="completed.has(inspected) && results[inspected].changes.length">
            <span class="test-change" *ngFor="let change of results[inspected].changes">
              <strong>{{change.name}}</strong> {{formatValue(change.previous)}} <i class="fa fa-long-arrow-right" aria-hidden="true"></i> {{formatValue(change.value)}}
            </span>
          </div>
        </div>
      </div>
      <footer><button type="button" class="btn btn-outline-primary" (click)="closeInspector()">{{_(KEYS.CRUD.TEST_BACK_TO_DIAGRAM)}}</button></footer>
    </section>
  </ng-container>
</div>
